// extracted by mini-css-extract-plugin
export default {"user":"CompanyButton_user__GyNxT"};